import Section from 'components/forms/Section';
import {Grid, Typography} from '@material-ui/core';
import {DocumentCard} from 'components/documents';
import fields from '../fields';
import {useFieldData} from 'components/forms/hooks';
import {bootstrapOldForm} from 'components/forms/AutoSection';
import {useGetAllDocumentsSummary} from 'hooks/';
import {LoadingPage} from 'components';
import Show from 'components/utils/Show';

const AssociateSsl = props => {
    const {schema, initialValues} = bootstrapOldForm('AssociateSsl', fields);
    const {data, error, isLoading} = useGetAllDocumentsSummary();
    const [ssl, setSsl] = useFieldData('_ssl_id');

    const documents = data?.seaservice.filter(item => item.document_type === 'ssl') || [];

    return (
        <Section {...props} {...{schema, initialValues}}>
            <Typography variant='h6'>Sea Service Letter</Typography>
            <Typography variant='body1' align='left'>
                Select the SSL associated with your tankerman letter. If you
                haven't entered it yet, we'll link them when you enter the SSL.
            </Typography>
            <Show condition={isLoading}>
                <LoadingPage />
            </Show>
            <Show condition={!isLoading}>
                <Grid
                    container
                    direction='row'
                    wrap
                    spacing={2}
                    justify='center'
                >
                    {documents.map((doc, index) => (
                        <Grid
                            item
                            key={`${doc?.document_type}-${doc?.user_document_id}`}
                        >
                            <DocumentCard
                                document={doc}
                                title={doc.title}
                                subtitle={`${
                                    Math.round(doc.subtitle * 10) / 10
                                } Sea Days Credit`}
                                subtitle2={doc.subtitle2}
                                otherData={`Submitted ${new Date(
                                    doc.user_document.date_posted
                                ).toLocaleDateString()}`}
                                onClick={() => setSsl(doc.document_id)}
                                selected={doc.document_id === ssl}
                                variant='listItem'
                            />
                        </Grid>
                    ))}
                    <Show condition={!error}>
                        <Grid item>
                            <DocumentCard
                                title='Skip'
                                subtitle='Link during SSL entry'
                                onClick={() => setSsl(null)}
                                selected={!ssl}
                                variant='listItem'
                            />
                        </Grid>
                    </Show>
                    <Show condition={error}>
                        <DocumentCard
                            title='Oops!'
                            subtitle="We couldn't load your SSLs, please reload to try again"
                            variant='listItem'
                            error
                        />
                    </Show>
                </Grid>
            </Show>
        </Section>
    );
};

export default AssociateSsl;
